// extracted by mini-css-extract-plugin
export default {"stickyHeader":"Routine_stickyHeader__FipcE","sticky":"Routine_sticky__APVcu"};